module.exports = __webpack_public_path__ + "static/img/EE.bd8cf34f.svg";